// The one button style for the Tailwind screens (BRK-S264), the twin of the
// MUI theme's buttons (docs/design-system.md): 36px, or 32px small, body text
// at 500, and at least 44px under a coarse pointer, whatever the size.
//
// `primary` is the view's one filled accent; everything else beside it is
// `secondary`, outlined, so a page never offers two equal calls to action.
// It returns classes, so a link that reads as a button (a list's "Add
// account") and a real <button> look the same.

type ButtonVariant = "primary" | "secondary";
type ButtonSize = "md" | "sm";

const BASE =
  "inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 [@media(pointer:coarse)]:min-h-11";

const SIZE: Record<ButtonSize, string> = {
  md: "h-9 px-4 text-body",
  sm: "h-8 px-3 text-meta",
};

const VARIANT: Record<ButtonVariant, string> = {
  primary: "bg-brk-accent text-white hover:bg-brk-accent-strong",
  secondary:
    "border border-brk-border bg-brk-panel text-brk-text hover:bg-brk-bg",
};

export function buttonClass({
  variant = "primary",
  size = "md",
  full = false,
}: {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Runs the width of its column: the sign-in card's one action. */
  full?: boolean;
} = {}): string {
  return [BASE, SIZE[size], VARIANT[variant], full ? "w-full" : ""]
    .filter(Boolean)
    .join(" ");
}

/** A small text control (Remove, + Add phone, a footer link) keeps its look,
 *  and grows to at least a 44×44 target under a coarse pointer (BRK-S264).
 *  The width matters too: a short label is only as wide as its text. */
export const TOUCH_TARGET =
  "[@media(pointer:coarse)]:inline-flex [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:min-w-11 [@media(pointer:coarse)]:items-center";

/** An icon-only control: a 44px square under a coarse pointer. */
export const TOUCH_SQUARE =
  "[@media(pointer:coarse)]:h-11 [@media(pointer:coarse)]:w-11";
